import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, App as AntdApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { theme } from './theme';
import Login from './pages/Login';
import Layout from './pages/Layout';
import Dashboard from './pages/Dashboard';
import PropertyStructure from './pages/PropertyStructure';
import User from './pages/User';
import Appointment from './pages/Appointment';
import Checkin from './pages/Checkin';
import PrintTemplate from './pages/PrintTemplate';
import Announcement from './pages/Announcement';

function AuthGuard() {
  const token = localStorage.getItem('token');
  const userRaw = localStorage.getItem('user');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  let userType = null;
  try { userType = userRaw ? (JSON.parse(userRaw) || {}).type : null; } catch {}
  if (userRaw && userType !== 'admin' && userType !== 'manager') {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return <Navigate to="/login" replace />;
  }
  return <Layout />;
}

function App() {
  return (
    <ConfigProvider theme={theme} locale={zhCN}>
      <AntdApp>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={<AuthGuard />}
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="property" element={<PropertyStructure />} />
            <Route path="user" element={<User />} />
            <Route path="appointment" element={<Appointment />} />
            <Route path="checkin" element={<Checkin />} />
            <Route path="print" element={<PrintTemplate />} />
            <Route path="announcement" element={<Announcement />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;
